import { createQueryKeys } from 'shared/api/query-keys';

export const notificationQueryKeys = createQueryKeys('notifications').withList().value();
